import { render } from "./lucky.vue?vue&type=template&id=5e4af2e8"
import script from "./lucky.vue?vue&type=script&lang=js"
export * from "./lucky.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__